module.exports = __webpack_public_path__ + "img/f-50-round.4c02eb7e.png";